import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * ProtectedRoute — gates all authenticated routes.
 *
 * States:
 *   - isLoading: show full-screen spinner while restoring Cognito session on mount
 *   - !isAuthenticated: redirect to /login
 *   - authenticated: render child routes via <Outlet />
 */
export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: 'var(--bg, #0f1117)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span style={{ fontFamily: 'Georgia, serif', fontSize: 20, fontWeight: 'bold', color: 'var(--text-primary, #e8ecf1)', letterSpacing: 0.3 }}>
            <span style={{ color: '#4f6ef7' }}>N</span>
            <span style={{ color: '#22d3ee' }}>N</span>
            {' '}NexoNurse
          </span>
        </div>
        <svg
          className="animate-spin"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          style={{ color: '#4f6ef7' }}
        >
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity="0.2" />
          <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        </svg>
        <div style={{ fontSize: 13, color: 'var(--text-muted, #8892a4)' }}>
          Loading…
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
